import { forwardRef, useMemo } from 'react'

import { TreeItem } from '../treeItem/TreeItem'

import { IListOfItemsProps } from './models/listOfItemsProps'

export const ListOfItems = forwardRef<HTMLUListElement, IListOfItemsProps>(
  ({ items, selectedItems, className, onItemSelect }, listRef) => {
    const treeItems = useMemo(
      () =>
        items.map((it) => {
          const matched = selectedItems.find((selected) => selected.itemId === it.itemId)
          const isChecked = matched?.checkedState === 'full'
          const isIndeterminate = matched?.checkedState === 'indeterminate'

          return (
            <TreeItem
              isSelected={isChecked}
              isIndeterminate={isIndeterminate}
              itemId={it.itemId}
              title={it.title}
              nestedItems={it.nestedItems}
              selectedItems={selectedItems}
              key={it.itemId}
              onItemSelect={onItemSelect}
            />
          )
        }),
      [items, selectedItems, onItemSelect]
    )

    return (
      <ul ref={listRef} className={className}>
        {treeItems}
      </ul>
    )
  }
)
